






























































import inlineTextEdit from "../components/inlineTextEdit.vue";
import gbutton from "../components/button.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import warningPopup, {WarningInterface} from "../components/warningPopup.vue"

import { PassThrough } from "stream";
import { frontendClient } from "../lib/client";
import { error } from "util";
import moment,{ weekdays, invalid} from "moment";
import { clearTimeout } from "timers";

@Component({
    components:{
        inlineTextEdit,
        gbutton
    }
})
export default class Root extends Vue {
    loading:boolean = false;
    username: string = null;
    password: string = null;
    error:boolean = false;

    alerts:{
        title: string,
        body: string,
        timestamp: number,
        date:(String | Date);
    }[] = null;

    @Prop({}) loggedIn: boolean;
    pnDeregTimeout: any;
    
    mounted(){
        if(this.loggedIn){
            if(frontendClient.userData.rank == "admin"){
                window.location.assign("/a")
            }else{
                window.location.assign("/home")
            }
            
        }

        this.getAlerts();

        this.pnDeregTimeout = setTimeout(() => {
            this.pnDeregTimeout = null;
            navigator.serviceWorker.ready.then((reg) => {
                reg.pushManager.getSubscription().then((subscription) => {
                    if(!subscription) {return;}

                    subscription.unsubscribe().then((successful) => {
                        // You've successfully unsubscribed
                    }).catch((e) => {
                        // Unsubscription failed
                    })
                    
                    frontendClient.post("auth/vapid/deregister",<any> subscription);
                })
            });
        },3500)
    }

    beforeDestroy() {
        if(this.pnDeregTimeout) {
            clearTimeout(this.pnDeregTimeout);
        }
    }

    updateUsername(value){
        this.username = value;
        this.error = false;
    }
    updatePassword(value){
        this.password = value;
        this.error = false;
    }


    async submitForm(){
        this.loading = true;
        setTimeout(async () => {
            let loginRequest = await frontendClient.postEx("auth/login", {
                username: this.username,
                password: this.password
            }).then(() => {
                location.reload();
            }).catch((err) => {
                this.error = true;
                this.loading=false;
                frontendClient.giveError("Incorrect credentials");
            })
        },750);
    }

    async getAlerts(){
        this.alerts = await frontendClient.post("alerts/latest",{});

        for(let i=this.alerts.length - 1; i>=0; i--){
            console.log(this.alerts[i].timestamp,(Date.now() - 86400000));
            if(this.alerts[i].timestamp > (Date.now() - 86400000)){
                this.alerts[i].date = moment(this.alerts[i].timestamp).format("ddd, DD/MM/YYYY");
            }else{
                console.log("NOT TODAY");
                this.alerts.splice(i,1);
            }
        }
    }

    async submitFlag(){
        let warning = new warningPopup();
        let warningItem:WarningInterface = {
            text:"Please contact the BTO office to recover your account",
            options:[
                {
                    text:"Okay",
                    function: "resolve"
                }
            ]
        }
        await warning.create(this, warningItem).then(() => {
        })
    }
}
